import { Button, Input, Space, Toast } from '@douyinfe/semi-ui';
import { useEffect, useState } from 'react';
import { useEventBus } from '@byted/hooks';
import { IconThumbUpStroked } from '@douyinfe/semi-icons';
import { useParams } from '@jupiter/plugin-runtime/router';
import { useReply } from '@/hooks/useReply';

import {
  Comment,
  Reply,
} from '@/typings/open.platform.forum_bff/namespaces/forum';
import useBiz from '@/context/useBiz';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useLike } from '@/hooks/useLike';
import { reportCreateReply } from '@/report';

type Props = {
  comment: Comment | Reply;
};
function isReply(man: Reply | Comment): man is Reply {
  return man && 'CommentId' in man;
}

// 感觉要用 useSwr 优化
export const ReplyOperation = ({ comment }: Props) => {
  const [visible, setVisible] = useState(false);
  const { run: postReply, loading } = useReply();
  const [replyContent, setReplyContent] = useState('');
  const { ifLogin } = useUserInfo();
  const biz = useBiz(state => state.biz);
  const { trigger: reloadReply } = useEventBus('RELOAD_REPLY');
  const { toggleLike, togglingLike } = useLike();
  const [isLiked, setIsLike] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  // const likeCount = comment.Liked;

  const { postId } = useParams<{ postId: string }>();
  const { User } = useUserInfo();

  useEffect(() => {
    if (comment.IsLiked && !comment.Liked) {
      setLikeCount(1);
    } else {
      setLikeCount(comment.Liked ?? 0);
    }
    setIsLike(Boolean(comment.IsLiked));
  }, [comment.Liked, comment.IsLiked]);

  if (!ifLogin) {
    return null;
  }

  return visible ? (
    <div>
      <Input
        className="min-w-[300px]"
        placeholder="添加公开回复"
        onChange={value => {
          setReplyContent(value);
        }}
      />
      <Space className="mt-2">
        <Button
          onClick={() => {
            setVisible(false);
          }}>
          取消
        </Button>
        <Button
          loading={loading}
          onClick={async () => {
            if (!replyContent) {
              return Toast.error('回复内容不能为空');
            }
            const res = await postReply({
              CommentId: isReply(comment) ? comment.CommentId : comment.Id,
              Html: replyContent,
              Uid: '',
              ToUserId: comment.UserInfo?.Id || '',
              Biz: biz,
            });
            if (isReply(comment)) {
              // 回复评论下的回复的埋点
              reportCreateReply({
                post_id: postId,
                comment_id: comment.CommentId,
                reply_id: res.ReplyId,
                uid: User?.Id || '',
                to_uid: comment.UserId,
              });
            } else {
              // 回复评论的埋点
              reportCreateReply({
                post_id: postId,
                comment_id: comment.Id,
                uid: User?.Id || '',
                to_uid: comment.UserId,
              });
            }
            reloadReply(isReply(comment) ? comment.CommentId : comment.Id);
            return setVisible(false);
          }}>
          回复
        </Button>
      </Space>
    </div>
  ) : (
    <Space>
      <Button
        type="tertiary"
        className={isLiked ? 'bg-[#F3F8FF] text-semi-color-primary' : ''}
        loading={togglingLike}
        onClick={async () => {
          await toggleLike({
            Uid: '',
            Type: isReply(comment) ? 'reply' : 'comment',
            TypeId: comment.Id,
            Biz: biz,
          });
          if (isLiked) {
            setLikeCount(n => n - 1);
            setIsLike(false);
          } else {
            setLikeCount(n => n + 1);
            setIsLike(true);
          }
          // trigger(isReply(comment) ? comment.CommentId : comment.Id);
        }}>
        <Space align="center">
          <IconThumbUpStroked className="mr-2" />
          {isLiked && '已'}点赞 {likeCount === 0 ? '' : likeCount}
        </Space>
      </Button>
      <Button
        onClick={() => {
          setVisible(true);
        }}>
        回复
      </Button>
    </Space>
  );
};
